import * as ApiManager from './_manager';
import store from '../store';

export const availLink = {
  login: payload => {
    return ApiManager.callGetReqApi (
      `/guest/company/${payload.selected_company_id}/avail/link/${payload.uuid}`,
      payload
    );
  },
};
